import React from 'react';

export interface H2Props extends React.HTMLAttributes<HTMLHeadingElement> {}

/**
 * 기본 h2 제목 컴포넌트
 */
export const H2: React.FC<H2Props> = ({
  children,
  className = '',
  ...props
}) => {
  return (
    <h2
      className={className}
      {...props}
    >
      {children}
    </h2>
  );
};
